import React from "react";

import { Interpolation, css } from "@emotion/core";
import { Children, cloneElement, ReactNode } from "react";
import { useTheme } from "@zapier/design-system";

type AsyncOverlayProps = {
  children: React.ReactElement;
  /** Is indicator visible */
  isVisible?: boolean;
  /** Used to render a custom Indicator */
  renderAsyncIndicator: () => ReactNode;
};

// Delete after rebrand
const overlayCss = (): Interpolation => ({
  alignItems: "center",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "center",
  left: 0,
  position: "absolute",
  top: 0,
  width: "100%",
  // Used to render on top of dropdown menus
  zIndex: 901,
});

const rebrandOverlayCss = css`
  align-items: center;
  background-color: rgba(255, 253, 249, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 901;
`;

/**
 * Renders a loading indicator on top of children content
 */
export const AsyncOverlay = ({
  children,
  isVisible = false,
  renderAsyncIndicator,
}: AsyncOverlayProps) => {
  const { isRebrand } = useTheme();

  const childrenProps = children?.props ?? {};
  const childrenStyle = childrenProps?.style ?? {};

  // Clone the child and set it's position to relative if needed.
  // This allows the overlay to seamlessly cover the whole
  // area of the child.
  return cloneElement(
    children,
    {
      ...childrenProps,
      style: {
        ...childrenStyle,
        position: childrenStyle?.position ?? "relative",
      },
    },
    [
      ...Children.toArray(children?.props?.children),
      isVisible && (
        <div css={isRebrand ? rebrandOverlayCss : overlayCss} key="indicator">
          {renderAsyncIndicator()}
        </div>
      ),
    ]
  );
};
